import {
  getAllDeveloper,
  getRoomsByBuildingId,
  getBuildingByDeveloperId,
  getRoom,
  getRobotsByRoomId,
  createBuilding,
  updateBuilding,
  savehouseTypePosition,
  fetchBuildingById,
  updateRoom,
  createRoom,
  getCameraByBuildingId,
  updateCamera,
  createCamera,
  removeCamera,
  fetchPoints,
  saveRoomPositionPointSequence,
  getTotalInfoByHostid,
  getPointMaterials,
  updatePointMaterial,
  deletePointMaterial,
  addPointMaterial,
  createPrimaryPoint,
  createSecondaryPoint,
  updatePrimaryPoint,
  updateSecondaryPoint,
  delPrimaryPoint,
  delSecondaryPoint,
  setRecommend,
  delRobotInRoom,
  bindRobotInRoom,
  getRobotsByDeveloperId,
  onOff,
  roomOnOff,
  delRoom,
  getGuideList,
  addGuide,
  updateGuide,
  removeGuide,
  getGuidePointList,
  getAllTemiPatternByHostId,
  addPattern,
  updatePattern,
  removePattern,
  deleteBackgroundMusicById,
  getDroneByBuildingId,
  updateDrone,
  createDrone,
  removeDrone,
  getBuildingMoreById,
  createBuildingMore,
  updateBuildingMore,
  getGuidePointListById,
} from '@/services/api'

export default {
  state: {
    allDeveloper: [], // 开发商列表
    buildings: [], // 开发商下楼盘列表
    building: {}, // 楼盘信息
    buildingMore: {}, //更多楼盘信息
    buildingRooms: [], // 楼盘房间信息
    roomDetail: {}, // 房间详情
    patternDetail: [], // 场景详情
    robots: [], // 房间下机器人列表
    pointMaterials: [], // 点位素材
    cameras: [], // 楼盘摄像头
    guide: [], //导览路线
    totalInfo: null,
    drones: [], //无人机素材
    allPointList: [], //导览路线点位以及素材
  },

  effects: {
    *getAllDeveloper(_, { call, put }) {
      const res = yield call(getAllDeveloper)
      yield put({
        type: 'saveAllDeveloper',
        payload: res,
      })
    },
    *getBuildings({ payload }, { call, put }) {
      const res = yield call(getBuildingByDeveloperId, payload, true)
      yield put({
        type: 'saveBuildings',
        payload: res,
      })
    },
    *getBuildingById({ payload }, { call, put }) {
      const res = yield call(fetchBuildingById, payload)
      yield put({
        type: 'saveBuilding',
        payload: res,
      })
    },
    *getRoomsByBuildingId({ payload }, { call, put }) {
      const res = yield call(getRoomsByBuildingId, payload)
      if (res) {
        res.forEach(item => (item.key = item.id))
      }
      yield put({
        type: 'saveRoomsByBuildingId',
        payload: res,
      })
    },
    *getCameraByBuildingId({ payload }, { call, put }) {
      const res = yield call(getCameraByBuildingId, payload)
      yield put({
        type: 'saveCameraByBuildingId',
        payload: res,
      })
    },
    *getRobotsByRoomId({ payload }, { call, put }) {
      const res = yield call(getRobotsByRoomId, payload)
      yield put({
        type: 'saveRobotsByRoomId',
        payload: res,
      })
    },
    *getRoom({ payload }, { call, put }) {
      const res = yield call(getRoom, payload)
      yield put({
        type: 'saveRoom',
        payload: res,
      })
    },
    *savehouseTypePosition({ payload: positions }, { call, put }) {
      yield call(savehouseTypePosition, positions)
      yield put({
        type: 'getRoom',
        payload: positions[0].roomId,
      })
    },
    *createBuilding({ payload }, { call, put }) {
      yield call(createBuilding, payload)
      yield put({
        type: 'getBuildings',
        payload: payload.developerId,
      })
    },
    *updateBuilding({ payload }, { call, put }) {
      yield call(updateBuilding, payload)
      yield put({
        type: 'getBuildingById',
        payload: payload.id,
      })
    },
    *updateRoom({ payload }, { call, put }) {
      yield call(updateRoom, payload)
      yield put({
        type: 'getRoom',
        payload: payload.id,
      })
    },
    *addPattern({ payload }, { call, put }) {
      yield call(addPattern, payload)
      yield put({
        type: 'getAllTemiPatternByHostId',
        payload: payload.hostId,
      })
    },
    *updatePattern({ payload }, { call, put }) {
      yield call(updatePattern, payload)
      yield put({
        type: 'getAllTemiPatternByHostId',
        payload: payload.hostId,
      })
    },
    *bindRobotInRoom({ payload }, { call, put }) {
      yield call(bindRobotInRoom, payload)
      yield put({
        type: 'getRobotsByRoomId',
        payload: payload.roomId,
      })
    },
    *delRobotInRoom({ payload }, { call, put }) {
      yield call(delRobotInRoom, payload)
      yield put({
        type: 'getRobotsByRoomId',
        payload: payload.roomId,
      })
    },
    *delRoom({ payload }, { call, put }) {
      yield call(delRoom, payload)
      yield put({
        type: 'getRoom',
      })
    },
    *createPrimaryPoint({ payload }, { call, put }) {
      yield call(createPrimaryPoint, payload)
      yield put({
        type: 'queryPoints',
        payload: payload.roomId,
      })
    },
    *createSecondaryPoint({ payload }, { call, put }) {
      yield call(createSecondaryPoint, payload)
      yield put({
        type: 'queryPoints',
        payload: payload.roomId,
      })
    },
    *updatePrimaryPoint({ payload }, { call, put }) {
      yield call(updatePrimaryPoint, payload)
      yield put({
        type: 'queryPoints',
        payload: payload.roomId,
      })
      yield put({
        type: 'getRoom',
        payload: payload.roomId,
      })
    },
    *updateSecondaryPoint({ payload }, { call, put }) {
      yield call(updateSecondaryPoint, payload)
      yield put({
        type: 'queryPoints',
        payload: payload.roomId,
      })
      yield put({
        type: 'getRoom',
        payload: payload.roomId,
      })
    },
    *delPrimaryPoint({ payload }, { call, put }) {
      yield call(delPrimaryPoint, payload.id)
      yield put({
        type: 'queryPoints',
        payload: payload.roomId,
      })
      yield put({
        type: 'getRoom',
        payload: payload.roomId,
      })
    },
    *delSecondaryPoint({ payload }, { call, put }) {
      yield call(delSecondaryPoint, payload.id)
      yield put({
        type: 'queryPoints',
        payload: payload.roomId,
      })
      yield put({
        type: 'getRoom',
        payload: payload.roomId,
      })
    },
    *createRoom({ payload }, { call, put }) {
      yield call(createRoom, payload)
      yield put({
        type: 'getRoomsByBuildingId',
        payload: payload.buildingId,
      })
    },
    *updateCamera({ payload }, { call, put }) {
      yield call(updateCamera, payload)
      yield put({
        type: 'getCameraByBuildingId',
        payload: payload.buildingId,
      })
    },
    *createCamera({ payload }, { call, put }) {
      yield call(createCamera, payload)
      yield put({
        type: 'getCameraByBuildingId',
        payload: payload.buildingId,
      })
    },
    *removeCamera({ payload }, { call, put }) {
      yield call(removeCamera, payload.id)
      yield put({
        type: 'getCameraByBuildingId',
        payload: payload.buildingId,
      })
    },
    *saveRoomPositionPointSequence({ payload }, { call, put }) {
      yield call(saveRoomPositionPointSequence, payload)
    },
    *getTotalInfoByHostid({ payload }, { call, put }) {
      const res = yield call(getTotalInfoByHostid, payload)
      yield put({
        type: 'saveTotalInfo',
        payload: res,
      })
    },
    *getAllTemiPatternByHostId({ payload }, { call, put }) {
      const res = yield call(getAllTemiPatternByHostId, payload)
      yield put({
        type: 'savePattern',
        payload: res,
      })
    },
    *getPointMaterials({ payload }, { call, put }) {
      const res = yield call(getPointMaterials, payload)
      yield put({
        type: 'savePointMaterials',
        payload: res,
      })
    },
    *addPointMaterial({ payload }, { call, put }) {
      yield call(addPointMaterial, payload)
      yield put({
        type: 'getPointMaterials',
        payload: payload,
      })
    },
    *addPointMaterialNew({ payload }, { call, put }) {
      yield call(addPointMaterial, payload)
        yield put({
          type: 'queryGuidePointListById',
          payload: payload.guideId,
        })
    },
    *updatePointMaterial({ payload }, { call, put }) {
      yield call(updatePointMaterial, payload)
      yield put({
        type: 'getPointMaterials',
        payload: payload,
      })
    },
    *updatePointMaterialNew({ payload }, { call, put }) {
      yield call(updatePointMaterial, payload)
        yield put({
          type: 'queryGuidePointListById',
          payload: payload.guideId,
        })
    },
    *deletePointMaterial({ payload }, { call, put }) {
      yield call(deletePointMaterial, payload.id)
      yield put({
        type: 'getPointMaterials',
        payload: payload,
      })
    },
    *deletePointMaterialNew({ payload }, { call, put }) {
      yield call(deletePointMaterial, payload.id)
      yield put({
        type: 'queryGuidePointListById',
        payload: payload.guideId,
      })
    },
    *queryPoints({ payload: roomId }, { call, put }) {
      const points = yield call(fetchPoints, roomId)

      // 根据 sequence 字段排序
      points.forEach(group => {
        group.positionPointDtos.sort((a, b) => a.sequence - b.sequence)
      })
      points.sort((a, b) => a.sequence - b.sequence)

      yield put({
        type: 'savePoints',
        payload: points,
      })
    },
    *setRecommend({ payload }, { call, put }) {
      yield call(setRecommend, payload)
      yield put({
        type: 'getBuildings',
        payload: payload.developerId,
      })
    },
    *setOnOff({ payload }, { call, put }) {
      yield call(onOff, payload)
      yield put({
        type: 'getBuildings',
        payload: payload.developerId,
      })
    },
    *setRoomOnOff({ payload }, { call, put }) {
      yield call(roomOnOff, payload)
      yield put({
        type: 'getRoomsByBuildingId',
        payload: payload.buildId,
      })
    },
    *getRobotsByDeveloperId({ id }, { call, put }) {
      const res = yield call(getRobotsByDeveloperId, id)
      yield put({
        type: 'saveRobotsByDeveloperId',
        payload: res,
      })
    },
    *queryGuideList({ payload }, { call, put }) {
      const res = yield call(getGuideList, payload)
      yield put({
        type: 'saveGuideList',
        payload: res,
      })
    },
    *addGuide({ payload }, { call, put }) {
      yield call(addGuide, payload)
      yield put({
        type: 'queryGuideList',
        payload: payload.roomId,
      })
    },
    *updateGuide({ payload }, { call, put }) {
      yield call(updateGuide, payload)
      yield put({
        type: 'queryGuideList',
        payload: payload.roomId,
      })
    },
    *queryGuidePointListById({ payload }, { call, put }) {
      const res = yield call(getGuidePointListById, payload)
      yield put({
        type: 'saveAllPointList',
        payload: res.pointList,
      })
    },
    *queryPointList({ payload }, { call, put }) {
      const res = yield call(getGuidePointList, payload)
      return res
    },
    *remove({ payload }, { call, put }) {
      yield call(removeGuide, payload.id)
      yield put({
        type: 'queryGuideList',
        payload: payload.roomId,
      })
    },
    *removePattern({ payload }, { call, put }) {
      yield call(removePattern, payload.id)
      yield put({
        type: 'getAllTemiPatternByHostId',
        payload: payload.hostId,
      })
    },
    *removeMusic({ payload }, { call, put }) {
      yield call(deleteBackgroundMusicById, payload.id)
      yield put({
        type: 'queryGuideList',
        payload: payload.roomId,
      })
    },
    *getDroneByBuildingId({ payload }, { call, put }) {
      const res = yield call(getDroneByBuildingId, payload)
      yield put({
        type: 'saveDroneByBuildingId',
        payload: res,
      })
    },
    *updateDrone({ payload }, { call, put }) {
      yield call(updateDrone, payload)
      yield put({
        type: 'getDroneByBuildingId',
        payload: payload.buildingId,
      })
    },
    *createDrone({ payload }, { call, put }) {
      yield call(createDrone, payload)
      yield put({
        type: 'getDroneByBuildingId',
        payload: payload.buildingId,
      })
    },
    *removeDrone({ payload }, { call, put }) {
      yield call(removeDrone, payload.id)
      yield put({
        type: 'getDroneByBuildingId',
        payload: payload.buildingId,
      })
    },
    *getBuildingMoreById({ payload }, { call, put }) {
      const res = yield call(getBuildingMoreById, payload)
      yield put({
        type: 'saveBuildingMore',
        payload: res,
      })
    },
    *updateBuildingMore({ payload }, { call, put }) {
      yield call(updateBuildingMore, payload)
      yield put({
        type: 'getBuildingMoreById',
        payload: payload.buildingId,
      })
    },
    *createBuildingMore({ payload }, { call, put }) {
      yield call(createBuildingMore, payload)
      yield put({
        type: 'getBuildingMoreById',
        payload: payload.buildingId,
      })
    },
  },

  reducers: {
    saveBuilding(state, { payload }) {
      return { ...state, building: payload }
    },
    saveBuildings(state, { payload }) {
      return { ...state, buildings: payload }
    },
    saveRoomsByBuildingId(state, { payload }) {
      return { ...state, rooms: payload }
    },
    saveTotalInfo(state, { payload }) {
      return { ...state, totalInfo: payload }
    },
    savePattern(state, { payload }) {
      return { ...state, patternDetail: payload }
    },
    saveCameraByBuildingId(state, { payload }) {
      return { ...state, cameras: payload }
    },
    saveDroneByBuildingId(state, { payload }) {
      return { ...state, drones: payload }
    },
    saveRobotsByDeveloperId(state, { payload }) {
      return { ...state, developerAllRobots: payload }
    },
    saveRobotsByRoomId(state, { payload }) {
      return { ...state, robots: payload }
    },
    saveRoom(state, { payload }) {
      return { ...state, roomDetail: payload }
    },
    saveAllDeveloper(state, { payload }) {
      return { ...state, allDeveloper: payload }
    },
    savePoints(state, { payload }) {
      return { ...state, points: payload }
    },
    savePointMaterials(state, { payload }) {
      return { ...state, pointMaterials: payload }
    },
    saveGuideList(state, { payload }) {
      return { ...state, guide: payload }
    },
    saveBuildingMore(state, { payload }) {
      return { ...state, buildingMore: payload }
    },
    saveAllPointList(state, { payload }) {
      return { ...state, allPointList: payload }
    },
  },
}
